// extracted by mini-css-extract-plugin
export default {"form":"auth_form__C-c-4","heading":"auth_heading__nCjA0"};